// Needed for the new modules
import { Injectable } from '@angular/core';
import { ManagementService } from 'src/app/services/management.service';
import { BowmanCacheService } from 'bowman-cache';
import { BowmanLogger, BowmanLoggerService } from 'bowman-logger';
import { Observable, Observer } from 'rxjs';
import { GuiPluginDto } from '../app/shared/gui-plugin.dto';


@Injectable()
export class DynamicModuleService {
   private log: BowmanLogger = new BowmanLogger(this._loggerService, 'ModuleService');

   public internalModules: string[] = [];
   public availableModules: GuiPluginDto[] = [];
   constructor(private _loggerService: BowmanLoggerService, private _managementService: ManagementService, private _bowmanCache: BowmanCacheService) { }

   public isInternalModuleEnabled(pluginName: string): boolean {
      return this.internalModules.indexOf(pluginName) >= 0;
   }
   getAvailableModules(): GuiPluginDto[] {
      return this.availableModules;
   }
   loadModules(): Observable<GuiPluginDto[]> {
      return new Observable((observer: Observer<GuiPluginDto[]>) => {
         this._managementService.listGuiPlugins().subscribe(res => {
            if (res.status == 'OK') {
               let plugins: { [name: string]: GuiPluginDto } = res.result;
               for (let pluginName in plugins) {
                  this.internalModules.push(plugins[pluginName].name);
                  this.availableModules.push(plugins[pluginName]);
               }
               observer.next(this.availableModules);
               observer.complete();
            } else {
               observer.error(res.message);
               observer.complete();
            }
         }, err => {
            observer.error(err);
            observer.complete();
         });
      });
   }
}
